isExtraneousPopstateEvent